<template>
  <form @submit.prevent="submit" class="form-signin">
    <h1 class="h3 mb-10 font-weight-normal text-center">Forgot Password </h1>
    <div class="error-msg" v-if="authError"> <i class="fa fa-info-circle"></i>{{ authError }}</div>
    <fg-input type="email" label="Email" placeholder="Email" v-model="cred.email"></fg-input>
    <div class="error-msg" v-if="getErrors['email']">
      <i class="fa fa-info-circle"></i> {{getErrors['email'][0] }}
    </div>
    <fg-input type="text" label="code" placeholder="code" v-model="cred.code" v-if="step == 2"></fg-input>
    <div class="error-msg" v-if="getErrors['code'] && step == 2">
      <i class="fa fa-info-circle"></i> {{getErrors['code'][0] }}
    </div>
    <fg-input type="password" label="New Password" placeholder="New Password" v-model="cred.password" v-if="step == 2"></fg-input>
    <div class="error-msg" v-if="getErrors['password'] && step == 2">
      <i class="fa fa-info-circle"></i> {{getErrors['password'][0] }}
    </div>


    <button type="submit" class="btn btn-lg btn-primary btn-block" :disabled="isRequested">
      Recover Password
      <i v-if="isRequested" class="ti-line-dotted"></i>
    </button>
  </form>

</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
  data() {
    return {
      step: 1,
      cred: {
        email: '',
      },
      errors: {},
      authError: '',
      isRequested: false,
    }
  },
  created(){
    let localStep = localStorage.getItem('forgot-step');
    if(localStep){
      this.step = localStep;
    }
  },
  methods: {
    submit() {
      this.isRequested = true;
      this.cred.step = this.step;
      this.$baseApi.post('/forgot-password', this.cred).then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          localStorage.setItem('forgot-step', 2);
          
          if(this.step == 2){
             store.dispatch('SET_AUTH_USER', res.user);
            let token = {
              value: res.access_token,
              type: res.token_type,
              expires_at: res.expires_in
            };
            store.dispatch('SET_TOKEN', token);
            store.dispatch('SET_AUTH', true);
            store.dispatch('SET_PERMISSIONS', res.permissions);
            localStorage.setItem('token', token.value);
            localStorage.setItem("auth", JSON.stringify(res.user));
            localStorage.removeItem('forgot-step');
            router.push('/dashboard');
          }
          this.step = 2;
          this.isRequested = false;
          
        }
      }).catch((error) => {
        this.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.authError = error.response.data.messages[0];
        this.isRequested = false
      })

    }
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.errors))
    },
     trans(){
      return this.$store.getters.GET_TRANS;
    },
  },
};
</script>
<style scoped>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 100px auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
